
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { durationTime } from "@util/dates-and-times/duration";

@Component({
  name: 'TripDetailStatisticsDetail',
  components: {

  },
})
export default class TripDetailStatisticsDetail extends Vue {
  @Prop()
  private id: string;

  @Prop({ required: true })
  private value: string;

  @Prop({ default: '' })
  private unit: string;

  @Prop({ required: true })
  private unitDescription: string;

  get isDuration() {
    return this.unit === 'duration';
  }

  get time() {
    return durationTime(+this.value);
  }

  get totalHours() {
    return Math.floor((+this.value) / 60);
  }
}
